<div class="login">
   <mat-form-field>
      <mat-label>Account Number</mat-label>
      <input matInput type="number" [(ngModel)]="accountService.number" (keydown.enter)="check()" autocomplete="off" required autofocus />
      <mat-error>Required</mat-error>
   </mat-form-field>

   <mat-form-field>
      <mat-label>Pin</mat-label>
      <input matInput type="number" [(ngModel)]="accountService.pin" (keydown.enter)="check()" />
      <mat-hint>Optional</mat-hint>
   </mat-form-field>

   <button mat-icon-button color="accent" [disabled]="!accountService.number" (click)="check()">
      <mat-icon>arrow_forward</mat-icon>
   </button>
</div>

<div class="mat-error" *ngIf="accountService.error">{{accountService.error}}</div>
